import data from '../../../data/all.json';
import NimbleEmojiIndex from './nimble-emoji-index';

var emojiIndex = new NimbleEmojiIndex(data);
var emojis = emojiIndex.emojis;
var emoticons = emojiIndex.emoticons;


function search() {
  return emojiIndex.search.apply(emojiIndex, arguments);
}

export default { search: search, emojis: emojis, emoticons: emoticons };


//////////////////
// WEBPACK FOOTER
// ./~/emoji-mart/dist-es/utils/emoji-index/emoji-index.js
// module id = 8252
// module chunks = 2